import { Handle, Position, NodeResizer, type NodeProps } from "@xyflow/react";
import { Mail01 } from "@untitledui/icons";
import { useTranslation } from "react-i18next";

export const EmailNode = ({ data, selected }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const label = (data?.label as string) || t('workflows.editor.defaultLabels.email');

    return (
        <div className="rounded-lg bg-utility-brand-50 border-2 border-utility-brand-500 shadow-md min-w-[150px] w-full h-full">
            <NodeResizer
                color="var(--utility-brand-500)"
                isVisible={selected}
                minWidth={150}
                minHeight={60}
            />
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-brand-500" />
            <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-utility-brand-500" />
            <div className="flex flex-col gap-1 px-3 py-2 h-full justify-center">
                <div className="flex items-center gap-2 flex-wrap">
                    <Mail01 className="size-4 text-white flex-shrink-0" />
                    <span className="text-sm font-semibold text-white break-words">{label}</span>
                </div>
            </div>
        </div>
    );
};
